export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '1cae285', dateTime: 1790646541480 };